import React from "react";
import PropTypes from "prop-types";

import S from "./MobileBasicTable.module.css";
import { Link } from "react-router-dom";

export default function BasicTable({ headers, items = [], itemKey }) {
  if (!headers || !headers.length) {
    throw new Error("<BasicTable /> headers is required.");
  }

  const headerKeys = headers.map((header) => header.value);

  if (itemKey === null) {
    itemKey = headerKeys[0];
  }

  return (
    <table className={S.tableWrap}>
      {itemKey !== "noticeMobileTable" && (
        <thead className={S.tableHeader}>
          <tr>
            {headers.map((header, index) => {
              const cellProps = {
                className: header?.widthClass ? S[header.widthClass] : "",
                rowSpan: header?.rowSpan || 1, 
                colSpan: header?.colSpan || 1, 
              };
              if (header?.text === null) return <></>;
              return (
                <th 
                  key={index} 
                  className={`${S[header.widthClass]}`}
                  {...cellProps}
                >
                  {header.text}
                </th>
              );
            })}
          </tr>
        </thead>
      )}
      <tbody>
        {items.map((row, rowIndex) => (
          <tr key={rowIndex} data-index={row.idx ? row.idx : null}>
            {itemKey !== "noticeMobileTable" && (
              <td className={S.iqNum}>{row.idx}</td>
            )}
            <td colSpan={2}>
              <div className={S.tableTitle}>
                {row.url && row.idx ? (
                  <Link to={`/${row.url}/${row.idx}`}>
                    {row.title.text}
                  </Link>
                ) : row.title.text}
              </div>
              <div className={S.tableSubInfo}>
                <span className={S.writer}>{row.writer.text}</span><span> | </span><span className={S.date}>{row.date.text}</span>
                {itemKey === "iqMobileTable" && (
                  <>
                    <span> | </span><span>{row.status.text}</span>
                  </>
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

BasicTable.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  itemKey: PropTypes.string,
};
